import { Outlet } from 'react-router-dom';
import './layout.scss';
// import MenuHeader from './MenuHeader';

const AppLayout = () => {
  return (
    <div className="app-layout">
      {/* Old header (TN EMIS / bell / avatar / Logout) + Home menu bar —
          replaced by the new DashboardHeader rendered inside the page. */}
      {/* <Header /> */}
      {/* <MenuHeader /> */}
      <main className="app-main container-fluid">
        <Outlet />
      </main>
    </div>
  );
};

export default AppLayout;
